export default __webpack_public_path__ + "static/media/container_tracking-red.43cd5c1e.svg";